import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ProductDetail } from '../../types/product';
import ProductCard from './ProductCard';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  padding: 1rem 0;

  @media (min-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 1440px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const EmptyMessage = styled.p`
  text-align: center;
  color: var(--gray-dark);
  font-size: 1.2rem;
  padding: 3rem 1rem;
  grid-column: 1 / -1;
`;

interface ProductGridProps {
  products: ProductDetail[];
  loading?: boolean;
}

const ProductGrid: React.FC<ProductGridProps> = ({ products, loading }) => {
  const { t } = useTranslation();
  const safeProducts = Array.isArray(products) ? products : [];

  if (loading) {
    return (
      <Grid>
        {[...Array(8)].map((_, index) => (
          <ProductCard key={index} loading />
        ))}
      </Grid>
    );
  }

  if (safeProducts.length === 0) {
    return (
      <Grid>
        <EmptyMessage>{t('products.noResults')}</EmptyMessage>
      </Grid>
    );
  }

  return (
    <Grid>
      {safeProducts.map((product) => (
        <ProductCard key={product.product_id} product={product} />
      ))}
    </Grid>
  );
};

export default ProductGrid;